import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

export interface CurrentUser {
  id: string;
  email: string;
  plan: string;
}

interface AuthContextValue {
  user: CurrentUser | null;
  loading: boolean;
  refresh: () => Promise<void>;
  logout: () => Promise<void>;
}

const AuthContext = createContext<AuthContextValue | null>(null);

// Blok 4, Týž. 14 — jednoduchý auth context (cookie-based session, žiadny Redux/Zustand
// netreba pre tento rozsah). Načíta /auth/me pri štarte appky.
export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<CurrentUser | null>(null);
  const [loading, setLoading] = useState(true);

  async function refresh(): Promise<void> {
    try {
      const res = await fetch('/api/v1/auth/me');
      setUser(res.ok ? await res.json() : null);
    } finally {
      setLoading(false);
    }
  }

  async function logout(): Promise<void> {
    await fetch('/api/v1/auth/logout', { method: 'POST' });
    setUser(null);
  }

  useEffect(() => {
    void refresh();
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, refresh, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth musí byť vnútri <AuthProvider>');
  return ctx;
}
